import React from "react";
import PartyCreateForm from "./PartyCreateForm";

export default function BuyerForm() {
  return <PartyCreateForm type="buyer" />;
}
